import request from '../helpers'

const state = {
  loading: false,
  loggedIn: false,
  OtpVerified: true,
  user: {},
  users: [],
  freightforwarders:[]
}

const mutations = {
  CHANGE_LOADING_STATE(state, loading) {
    state.loading = loading
  },
  SET_USER (state, user) {
    if (user != null) {
      state.user = Object.assign({}, user)
      state.loggedIn = true 
      state.OtpVerified = user.otpVerified
      localStorage.setItem("UserRoleId",user.userRoleId);
      
    } else {
      state.user = {}
      state.loggedIn = false
      state.OtpVerified = false
    }
  },
  SET_OTP (state, otpVerified) {
    if (otpVerified != null) {
      state.OtpVerified = otpVerified
    } else {
      state.OtpVerified = false
    }
  },
  UPDATE_USERS (state, users) {
    state.users = users;
    state.freightforwarders = users.filter(o=>o.userRoleId ==5);  
  },
  APPEND_UPDATE_USER (state, user) {
    var currentIndex = state.users.findIndex(u => u.id == user.id)
    if (currentIndex == -1) {
      state.users.push(user.value) 
    }
    else
      state.users.splice(currentIndex, 1, user) // necessary to force vue to detect the change
    if (state.user.id == user.id)
      state.user = user;
  },
  DELETE_USER (state, user) {
    if (state.user == user.id) {
      axios.defaults.headers.common['Authorization'] = null;
      state.loggedIn = false;
    } else {
      var currentIndex = state.users.findIndex(c => c.id == user.id)
      if (currentIndex != -1)
        state.users.splice(currentIndex, 1)
    }
  }
}

const actions = {
  initialize({ state }) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.user.token;
  },
  authenticate ({ commit }, credentials) {
    return request({ method: 'post', url: 'user/authenticate', data: credentials, successCallback: user => {
      user.otpVerified = true;
      if(user.otpEnabled != undefined && user.otpEnabled == true) {
        user.otpVerified = false;
      } 
      commit('SET_USER', user);
      console.log("setting token")
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token;
    }});
  },
  logout ({ commit }) {
    axios.defaults.headers.common['Authorization'] = null;
    commit('SET_USER', null); 
    
  },
  verifyOtp ({ commit }, credentials) {
    return request({ method: 'post', url: 'user/verifyOtp', data: credentials, successCallback: message => {
      let otpVerified = true;
      commit('SET_OTP', otpVerified);
    }});
  },
  resendOtp({ commit }, userInfo) {
    return request({ commit: commit, method: 'post', url: `user/resendOtp`, data: userInfo, successCallback: message => {
      console.log("OTP Resent")

    }});
  },
  getUsers({ commit }) {
    return request({ commit: commit, method: 'get', url: 'user/list', successCallback: users => {
      commit('UPDATE_USERS', users); 
    }});
  },
  saveUser({ commit }, data) {
    return request({ commit: commit, method: 'post', url: 'user', data: data, successCallback: user => {
      commit('APPEND_UPDATE_USER', user);
    }});
  },
  saveFFUser({ commit }, data) {
    return request({ commit: commit, method: 'post', url: 'user/updateFF', data: data, successCallback: user => {
      //commit('APPEND_UPDATE_USER', user);
    }});
  },
  deleteUser({ commit }, data) {
    return request({ commit: commit, method: 'delete', url: `user/${data.id}`, successCallback: user => {
      commit('DELETE_USER', user);
    }});
  },
  isAdmin({ commit }) {
    return state.user.userRoleId == 1
  },
  isClient({ commit }) {
    return state.user.userRoleId == 3
  },
  isFF({ commit }) {
    return state.user.userRoleId == 5
  }
}

const getters = {
  allowDelete(state) {
    return state.users.length > 1
  },
  getLoggedIn() {
    return state.loggedIn
  },
  currentUser() {
    return state.user
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
